import { Box, Button, Stack } from '@mui/material'

import { ItemThumbnailType } from '@/clients/utoniq-core/schema'
import { ItemReversibleThumbnail, ItemStatusCell } from '@/components/organisms'
import { ThumbnailActionAreaCell } from '@/components/pages/OwnedItemDetail/template/components/ThumbnailActionArea'
import { useRouter, useTranslation } from '@/core'
import { Cell } from '@/core/architecture'

import { State } from './'
import { ConsoleItemDescription } from './ConsoleItemDescription'

export type ConsoleItemDetailMerchProps = {
  loading: boolean
  item: State['item']
  isFlipped: boolean
  onReverseThumbnail: () => void
  onOpenFullScreen: () => void
  onOpenMultipleImage: () => void
}

export const ConsoleItemDetailMerch: Cell<ConsoleItemDetailMerchProps> = ({
  loading,
  item,
  isFlipped,
  onReverseThumbnail,
  onOpenFullScreen,
  onOpenMultipleImage,
}) => {
  const { t } = useTranslation('consoleItemDetail')
  const { routerPages } = useRouter()

  return (
    <>
      <Box sx={{ position: 'relative' }}>
        <ThumbnailActionAreaCell
          onOpenFullScreen={onOpenFullScreen}
          onOpenMultipleImage={onOpenMultipleImage}
          numberImage={item?.images?.length ?? 0}
        />
        <ItemReversibleThumbnail
          loading={loading}
          flipProps={{
            isFlipped,
          }}
          imageAreaProps={{
            thumbnail: item?.thumbnail,
            size:
              item?.thumbnailType === ItemThumbnailType.Square
                ? 'x-large-square'
                : 'x-large',
            onClick: onReverseThumbnail,
          }}
        />
      </Box>
      {item && !loading && (
        <Stack sx={{ pt: 3 }}>
          <ItemStatusCell
            salesCondition={item.salesCondition}
            isPublished={item.isPublished}
            isDrm={item.isDrm}
            isPremium={item.isPremium}
          />
        </Stack>
      )}
      <ConsoleItemDescription item={item} loading={loading} />

      <Box sx={{ mt: 6, mb: 2 }}>
        <Button variant="outlined" href={routerPages.ConsoleDeliveryManagement}>
          {t('merchButtonWord')}
        </Button>
      </Box>
    </>
  )
}
